import { ResponseData } from './InterestCheck';

export interface BasicInfoFormat {
  // institution_sub: any | undefined;
  user_id: any;
  user_name: any | undefined;
  user_name_kana: any | undefined;
  user_gender: any | undefined;
  user_birth_year: number | undefined;
  user_birth_month: any | undefined;
  user_birth_day: any | undefined;
  user_care_level: any | undefined;
  user_care_id: any | undefined;
  user_visit_day: any[] | undefined;
  // 以下 basicinfoにしかない要素
  planner: any | undefined;
  planner_job: any | undefined;
  program_planner: any | undefined;
  program_planner_job: any | undefined;
  independence_level_disabled_elderly: any | undefined;
  independence_level_dementia_elderly: any | undefined;
  user_wish: any | undefined;
  family_wish: any | undefined;
  disease_name: any | undefined;
  idc10_disease_name: any | undefined;
  illness_era: any | undefined;
  illness_year: any | undefined;
  illness_month: any | undefined;
  illness_day: any | undefined;
  hospitalization_era: any | undefined;
  hospitalization_year: any | undefined;
  hospitalization_month: any | undefined;
  hospitalization_day: any | undefined;
  discharge_era: any | undefined;
  discharge_year: any | undefined;
  discharge_month: any | undefined;
  discharge_day: any | undefined;
  course_of_treatment: any | undefined;
  // 合併症23項目 (LIFE 整合)
  complications_control_cerebrovascular_disease: boolean | undefined;
  complications_control_fracture: boolean | undefined;
  complications_control_pneumonia: boolean | undefined;
  complications_control_congestive_heart_failure: boolean | undefined;
  complications_control_urinary_tract_infection: boolean | undefined;
  complications_control_diabetes: boolean | undefined;
  complications_control_hypertension: boolean | undefined;
  complications_control_osteoporosis: boolean | undefined;
  complications_control_articular_rheumatism: boolean | undefined;
  complications_control_cancer: boolean | undefined;
  complications_control_depression_state: boolean | undefined;
  complications_control_dementia: boolean | undefined;
  complications_control_decubitus: boolean | undefined;
  complications_control_nervous_disease: boolean | undefined;
  complications_control_motor_disorder: boolean | undefined;
  complications_control_respiratory_disease: boolean | undefined;
  complications_control_circulatory_disease: boolean | undefined;
  complications_control_digestive_system_disease: boolean | undefined;
  complications_control_kidney_disease: boolean | undefined;
  complications_control_endocrine_disease: boolean | undefined;
  complications_control_skin_disease: boolean | undefined;
  complications_control_neurological_disease: boolean | undefined;
  complications_control_other: boolean | undefined;
}

export type ComplicationKey =
  | 'complications_control_cerebrovascular_disease'
  | 'complications_control_fracture'
  | 'complications_control_pneumonia'
  | 'complications_control_congestive_heart_failure'
  | 'complications_control_urinary_tract_infection'
  | 'complications_control_diabetes'
  | 'complications_control_hypertension'
  | 'complications_control_osteoporosis'
  | 'complications_control_articular_rheumatism'
  | 'complications_control_cancer'
  | 'complications_control_depression_state'
  | 'complications_control_dementia'
  | 'complications_control_decubitus'
  | 'complications_control_nervous_disease'
  | 'complications_control_motor_disorder'
  | 'complications_control_respiratory_disease'
  | 'complications_control_circulatory_disease'
  | 'complications_control_digestive_system_disease'
  | 'complications_control_kidney_disease'
  | 'complications_control_endocrine_disease'
  | 'complications_control_skin_disease'
  | 'complications_control_neurological_disease'
  | 'complications_control_other';

export const COMPLICATION_FIELDS: ReadonlyArray<{
  key: ComplicationKey;
  label: string;
}> = [
  { key: 'complications_control_cerebrovascular_disease', label: '脳血管疾患' },
  { key: 'complications_control_fracture', label: '骨折' },
  { key: 'complications_control_pneumonia', label: '誤嚥性肺炎' },
  { key: 'complications_control_congestive_heart_failure', label: 'うっ血性心不全' },
  { key: 'complications_control_urinary_tract_infection', label: '尿路感染症' },
  { key: 'complications_control_diabetes', label: '糖尿病' },
  { key: 'complications_control_hypertension', label: '高血圧症' },
  { key: 'complications_control_osteoporosis', label: '骨粗しょう症' },
  { key: 'complications_control_articular_rheumatism', label: '関節リウマチ' },
  { key: 'complications_control_cancer', label: 'がん' },
  { key: 'complications_control_depression_state', label: 'うつ病' },
  { key: 'complications_control_dementia', label: '認知症' },
  { key: 'complications_control_decubitus', label: '褥瘡' },
  { key: 'complications_control_nervous_disease', label: 'その他 神経疾患' },
  { key: 'complications_control_motor_disorder', label: 'その他 運動器疾患' },
  { key: 'complications_control_respiratory_disease', label: 'その他 呼吸器疾患' },
  { key: 'complications_control_circulatory_disease', label: 'その他 循環器疾患' },
  { key: 'complications_control_digestive_system_disease', label: 'その他 消化器疾患' },
  { key: 'complications_control_kidney_disease', label: 'その他 腎疾患' },
  { key: 'complications_control_endocrine_disease', label: 'その他 内分泌疾患' },
  { key: 'complications_control_skin_disease', label: 'その他 皮膚疾患' },
  { key: 'complications_control_neurological_disease', label: 'その他 精神疾患' },
  { key: 'complications_control_other', label: 'その他 疾病' },
];

// jsuites dropdown は falsy id (false/0/'') を「未選択」扱いする (jsuites.js:3294 if (!values))
// ため、boolean id 形式 [{id: false, name: 'なし'}] は使えない。plain string source で扱い、
// API 境界 (saveAllData / 初期値ロード) で boolean ↔ 'あり'/'なし' に変換する。
export const ARI_LABEL = 'あり';
export const NASHI_LABEL = 'なし';
export const ARI_NASHI_OPTIONS: ReadonlyArray<string> = [ARI_LABEL, NASHI_LABEL];

// eslint-disable-next-line @typescript-eslint/interface-name-prefix
export interface ICD10 {
  name: string;
  icd10: string;
}

// eslint-disable-next-line @typescript-eslint/interface-name-prefix
export interface Disease {
  name: string;
  icd10: string;
}

// eslint-disable-next-line @typescript-eslint/interface-name-prefix
export interface ICF {
  goal: string;
  icf: string;
  item: string;
}

export interface Support {
  program: string;
  code: string;
  item: string;
}

export interface PlanFormat {
  plan_id: any | undefined;
  user_id: any | undefined;
  created_at: any | undefined;
  updated_at: any | undefined;
  care_level: any | undefined;
  training: any | undefined;
  item: any | undefined;
  pattern: any | undefined;
  bundlemaster_key: any | undefined;
  note: any | undefined;
  short_goal_start_era: any | undefined;
  short_goal_start_year: any | undefined;
  short_goal_start_month: any | undefined;
  short_goal_finish_era: any | undefined;
  short_goal_finish_year: any | undefined;
  short_goal_finish_month: any | undefined;
  short_goal_achievement: any | undefined;
  short_goal_function: any | undefined;
  short_goal_function_icf: any | undefined;
  short_goal_activity: any | undefined;
  short_goal_activity_icf: any | undefined;
  short_goal_participation: any | undefined;
  short_goal_participation_icf: any | undefined;
  long_goal_start_era: any | undefined;
  long_goal_start_year: any | undefined;
  long_goal_start_month: any | undefined;
  long_goal_finish_era: any | undefined;
  long_goal_finish_year: any | undefined;
  long_goal_finish_month: any | undefined;
  long_goal_achievement: any | undefined;
  long_goal_activity: any | undefined;
  long_goal_activity_icf: any | undefined;
  long_goal_function: any | undefined;
  long_goal_function_icf: any | undefined;
  long_goal_participation: any | undefined;
  long_goal_participation_icf: any | undefined;
  program_1: any | undefined;
  program_support_1: any | undefined;
  program_note_1: any | undefined;
  program_frequency_1: any | undefined;
  program_time_1: any | undefined;
  program_practitioner_1: any | undefined;
  program_2: any | undefined;
  program_support_2: any | undefined;
  program_note_2: any | undefined;
  program_frequency_2: any | undefined;
  program_time_2: any | undefined;
  program_practitioner_2: any | undefined;
  program_3: any | undefined;
  program_support_3: any | undefined;
  program_note_3: any | undefined;
  program_frequency_3: any | undefined;
  program_time_3: any | undefined;
  program_practitioner_3: any | undefined;
  program_4: any | undefined;
  program_support_4: any | undefined;
  program_note_4: any | undefined;
  program_frequency_4: any | undefined;
  program_time_4: any | undefined;
  program_practitioner_4: any | undefined;
  program_planner: any | undefined;
  program_planner_job: any | undefined;
  outside_of_service: any | undefined;
  special_remarks: any | undefined;
  change: any | undefined;
  issue_factor: any | undefined;
  new: any | undefined;
  //TODO その他入力項目
  creation_year: any | undefined;
  creation_month: any | undefined;
  creation_day: any | undefined;
  last_creation_year: any | undefined;
  last_creation_month: any | undefined;
  last_creation_day: any | undefined;
  first_creation_year: any | undefined;
  first_creation_month: any | undefined;
  first_creation_day: any | undefined;
  social_participation: any | undefined;
  residence_environment: any | undefined;
  // (#854 D) 計画書側で編集可能な「利用者本人の希望」「家族の希望」。
  // 未入力の計画書ではフロント側で basicInfo.user_wish / basicInfo.family_wish を
  // 初期値としてフォールバックする。バックエンドは DynamoDB スキーマレスのため
  // 既存レコードに本属性が無くても API レイヤで欠落フィールドとして扱われる。
  user_wish: any | undefined;
  family_wish: any | undefined;
}

export interface BundleMaster {
  id: string;
  care_level: string;
  training: string;
  item: string;
  pattern: string;
  short_goal_function: string;
  short_goal_function_icf: string;
  short_goal_activity: string;
  short_goal_activity_icf: string;
  short_goal_participation: string;
  short_goal_participation_icf: string;
  long_goal_function: string;
  long_goal_function_icf: string;
  long_goal_activity: string;
  long_goal_activity_icf: string;
  long_goal_participation: string;
  long_goal_participation_icf: string;
  program_1: string;
  program_support_1: string;
  program_note_1: string;
  program_time_1: string;
  program_practitioner_1: string;
  program_2: string;
  program_support_2: string;
  program_note_2: string;
  program_time_2: string;
  program_practitioner_2: string;
  program_3: string;
  program_support_3: string;
  program_note_3: string;
  program_time_3: string;
  program_practitioner_3: string;
  program_4: string;
  program_support_4: string;
  program_note_4: string;
  program_time_4: string;
  program_practitioner_4: string;
  outside_of_service: string;
  special_remarks: string;
}

// 1 要介護レベル
export const CARE_LEVELS: { [key: string]: string } = {
  // 0: '要支援１',
  // 1: '要支援２',
  2: '要介護１',
  3: '要介護２',
  4: '要介護３',
  5: '要介護４',
  6: '要介護５',
  // 999: '要介護なし',
};

// 施設.
export interface Institution {
  company_name: string;
  created_at: string;
  institution_email: string;
  institution_id: string;
  institution_name: string;
  institution_name_kana: string;
  institution_status: string;
  institution_sub: string;
  updated_at: string;
  // "iPadCode": string;
  application_year_month: string;
  address: string;
  company_name_kana: string;
  ContactPerson: string;
  post_code: string;
  // "enabled": string;
  Administrator: string;
  institution_phone: string;
  institution_care_id: string;
  fax: string;
}

export interface MonthlyUsersData {
  monthUsersRecords: {
    userId: string;
    data: ResponseData[];
  }[];
}

export const LOADING = 'FUNCTIONAL_TRAINING_PLAN_LOADING';
// エラーでもFINISH
export const FINISH = 'FUNCTIONAL_TRAINING_PLAN_FINISH';

export const SUCCESS = 'FUNCTIONAL_TRAINING_PLAN_SUCCESS';
export const ERROR = 'FUNCTIONAL_TRAINING_PLAN_ERROR';
